var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActavivoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "107.862204%",
    y1: "50%",
    x2: "0%",
    y2: "49.8031552%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E832",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D94E",
    offset: "12.68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6CA61",
    offset: "22.73%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DBD6C",
    offset: "31.3697143%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57B473",
    offset: "38.5530172%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38AF77",
    offset: "44.6852939%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29AD78",
    offset: "52.2133615%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09AC88",
    offset: "61.109371%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8AE",
    offset: "83.7036668%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6BC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1---Home---Default-Content",
    transform: "translate(-32.000000, -12.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(32.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8224165,34.7110208 L24.9435579,34.7110208 C24.331108,34.7110208 23.793347,35.1223972 23.6190727,35.7216861 L23.1086977,37.4865414 C22.8497758,38.3829355 22.0406447,39 21.1244594,39 L15.9684275,39 C15.4107495,39 14.843113,38.4311833 15.0397941,37.9004571 L22.6979081,18.0985272 C23.6066245,15.6328085 25.9194944,14 28.5012448,14 L28.5012448,14 C31.0829952,14 33.3958652,15.6328085 34.3045815,18.0985272 L41.9602059,37.8979177 C42.156887,38.4311833 41.5892505,38.9974606 41.0315725,38.9974606 L35.6589424,38.9974606 C34.7477364,38.9974606 33.9435846,38.3880142 33.6771938,37.4992382 L33.1444121,35.7089893 C32.9676481,35.1173184 32.4298872,34.7110208 31.8224165,34.7110208 Z M32.111214,28.5302184 L31.0730367,25.0817674 C30.2290508,22.2757745 26.3327737,22.1183342 25.4962566,24.9268664 L25.4788292,24.9903504 C24.9186616,26.8694769 26.2979188,28.9289218 28.2224058,28.9289218 L31.8224165,28.9289218 C32.0265665,28.9314373 32.1709652,28.7308278 32.111214,28.5302184 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActavivoLogo);
export default __webpack_public_path__ + "static/media/actavivo_logo.d09cd45b45e26b2b44359a717d739dc3.svg";
export { ForwardRef as ReactComponent };